import { QueryFunction, useQuery } from 'react-query';
import { getAllUsers, GetAllUsersQueries, User } from '../../services/apiSLTP/users';

type UseUsersQueryOptions = {
    queries?: GetAllUsersQueries;
};

const getUsers: QueryFunction<User[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseUsersQueryOptions];
    const { queries } = options;

    const response = await getAllUsers(queries);
    return response.data;
};

export const useUsersQuery = (options: UseUsersQueryOptions) => {
    return useQuery(['users', options], getUsers);
};
